import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class CountryService {
    async queryCountry(params) {
        try {
            const response = await axios.get(`${config["apiUrl"]}countries/query`, {
                params,
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return null;
        }
    }

    handleError(error) {
        if (error.response?.status === 401) {
            AuthService.logout();
            window.location = "/login";
        }
        console.log("ERROR:: ", error.response?.data);
    }
}
export default new CountryService();
